/**
 * Recipe Database - Combined exports
 * 
 * ~60 recipes total across 4 effort levels:
 * - no-cook: 15 recipes
 * - one-pan: 20 recipes
 * - some-steps: 15 recipes
 * - full-cook: 10 recipes
 */

import NO_COOK_RECIPES from './no-cook';
import ONE_PAN_RECIPES from './one-pan';
import SOME_STEPS_RECIPES from './some-steps';
import FULL_COOK_RECIPES from './full-cook';

// All recipes combined
export const ALL_RECIPES = [
  ...NO_COOK_RECIPES,
  ...ONE_PAN_RECIPES,
  ...SOME_STEPS_RECIPES,
  ...FULL_COOK_RECIPES
];

// Export by effort level
export const RECIPES_BY_EFFORT = {
  'no-cook': NO_COOK_RECIPES,
  'one-pan': ONE_PAN_RECIPES,
  'some-steps': SOME_STEPS_RECIPES,
  'full-cook': FULL_COOK_RECIPES
};

// Individual exports
export { NO_COOK_RECIPES, ONE_PAN_RECIPES, SOME_STEPS_RECIPES, FULL_COOK_RECIPES };

// Default export
export default ALL_RECIPES;
